exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input {\n  display: block;\n  font-family: inherit;\n  font-size: 14px;\n  width: 20px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  outline: none;\n  padding: 10px 15px;\n  color: rgba(0, 0, 0, 0.7); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Temp/Avemov/Avemov-Angular/src/app/dynamic-form/components/form-checkbox/form-checkbox.component.scss
// module id = ../../../../../src/app/dynamic-form/components/form-checkbox/form-checkbox.component.scss
// module chunks = main